module.exports = __webpack_public_path__ + "img/blackjack1.a12545e1.webp";